<template>
  <li class="nav-item" :class="hasChildren ? 'dropdown-link dropdown-center' : null" @mouseover="mouseOver" @mouseleave="mouseLeave">
      <div class="d-flex justify-content-between">
        <router-link :to="mainNode.path"
                     :href="mainNode.path"
                     :target="mainNode.target"
                     class="nav-link font-big"
                     :class="hasChildrenLinksClass" v-on="hasChildren ? { click: toggleChildren } : {}"
                     >
          {{ mainNode.name[this.store.state.general.locale] }}
        </router-link>
        <span class="icon-span d-flex flex-column justify-content-center"
              v-if="hasChildren" @click="toggleChildren">
          <img :src="toggleChildrenArrow" alt=""/>
        </span>
      </div>
          <div :class="'dropdown-menu dropdown-link__container ' + dropDownAnimation()"
              v-if="hasChildren"
              v-show="showChildren"
          >
          <HeaderMenuChildComponent
              v-for="child in mainNode.children"
              :main-node="child"
              :key="child.id"
              :depth="depth + 1"
              />
        </div>
      </li>
</template>


<script>
import './headerMeniuChild.scss';
import angleDown from "/assets/images/angle-down.svg";
import angleUp from "/assets/images/angle-up.svg";
import {useStore} from "vuex";

  export default {
    name: 'HeaderMenuChildComponent',
    props: {
      mainNode: {
        type: Object,
        required: true,
      },
      depth: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        showChildren: false,
        angleDown: angleDown,
        angleUp: angleUp,
      }
    },

    setup() {
      const store = useStore();

      return {
        store,
      };
    },

    methods: {
      toggleChildren() {
        this.showChildren = !this.showChildren;
      },

      mouseOver() {
        this.showChildren = true;
      },

      mouseLeave() {
        this.showChildren = false;
      },

      dropDownAnimation() {
        if (this.depth) {
          return 'dropdown-link__container__right-animation'
        } else {
          return 'dropdown-link__container__down-animation'
        }
      },
    },

    computed: {
      hasChildrenLinksClass() {
        const state = this.hasChildren
        if (state) {
          return 'menu-link-drop'
        } else {
          return 'menu-link'
        }
      },

      hasChildren() {
        const { children } = this.mainNode
        return children && children.length > 0
      },

      toggleChildrenArrow() {
        return this.showChildren ? this.angleUp : this.angleDown;
      },
    }
  }

</script>